const ListTable = require('app/ui/list/Table');
const IFrame = require('app/ui/modal/IFrame');

class ListView {
	defaultOptions() {
		return {
			'selector': '.view-order-list',
			'tableContainerSelector': '.order-list-container',
			'filterFormSelector': '.order-list-search-form',
		};
	}

	constructor(options) {
		this.settings = $.extend(this.defaultOptions(), options);


		this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
		this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

		this.$container = $(this.settings.selector);
		if(this.$container.length <= 0){
			window.notify("Can't find container view with selector " + this.settings.selector,'danger');
		}

		this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
		this.$filterForm =  $(this.settings.filterFormSelector,this.$container);

		this.initialize();
	}

	initialize() {
		var self = this;
		
		this.initializeFilterForm();
		this.initializeListTable();
		this.initializeControlClick();
	
	}

	initializeControlClick(){
        $('body').on('click','.btn-control-delivery',function(){
            let $btn = $(this);
            let modal = new IFrame({
				'modalSize': 'full',
                'url': '/order/delivery/' + $btn.data('orderid') + '/show/',
            });

            modal.show();
			
			return false;
		});
	}

	initializeFilterForm(){
		var self = this;


		this.$filterBySuppliers = $('select[id="suppliers"]',this.$filterForm);
		this.$filterBySuppliers.on('change',this.onSubmitFilterForm);
		this.$filterBySuppliers.select2();
		
		this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
		this.$filterByRestaurant.on('change',this.onSubmitFilterForm);
		this.$filterByRestaurant.select2();


		this.$filterForm.on('submit',this.onSubmitFilterForm);

	}

	onSubmitFilterForm(event){
		event.preventDefault()
		event.stopPropagation();

		this.table.refresh();
	}


	initializeListTable(){
		var self = this;

		let fields = [
			'id',
			'restaurantName',
			'supplier { name }',
			'total',
			'createdAt'
		];

		this.table = new ListTable({
			'$container': this.$tableContainer,
			'tableClass': 'table table-striped order-list',
			'id': 'list-orders',
			'length': 50,
			'graphQL': {
				'queryType': 'restaurantOrders',
				'fields': fields,
				'parameters': this.buildGraphQLParameters,

			},
			'columns': [
				{
					'name': 'id',
					'label': window.translate('restaurant.order.id.label'),
					'class': 'order-id',
					'render': function(item,index){
						return item.node.id;
					},
				},
				{
					'name': 'createdAt',
					'label': window.translate('restaurant.order.createdAt.label'),
					'class': 'order-date',
					'ordered': true,
					'orderType': 'createdAt',
					'orderDir': 'DESC',
					'render': function(item,index){
						return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDay'));
					},
				},
				{
					'name': 'restaurant',
					'label': window.translate('restaurant.order.restaurant.label'),
					'class': 'order-restaurant',
					'render': function(item,index){
						return item.node.restaurantName;
					},
				},
				{
					'name': 'supplier',
					'label': window.translate('restaurant.order.supplier.label'),
					'class': 'order-supplier',
					'render': function(item,index){
						return item.node.supplier.name;
					},
				},
				{
					'name': 'total',
					'label': window.translate('total'),
					'class': 'order-total',
					'render': function(item,index){
						return window.formatFloat(item.node.total) + ' &euro;';
					},
				},
				{
					'name': 'actions',
					'label': '',
					'class': 'order-actions',
					'render': function(item,index){
						let $list = $('<ul/>')
						.addClass('list-inline btn-list-inline');

						// Ouverture d'une fancybox avec le détail de la commande
						let $btnShow = $('<a/>')
						.attr('href',"#")
						.addClass('btn btn-link text-primary btn-order-show')
						.attr('data-orderid',item.node.id)
						.attr('title',window.translate('restaurant.order.actions.show.label'))
						.append(
							$('<i/>')
							.addClass('fa fa-search')
						);

						// Contrôle des livraisons
						let $btnControl = $('<a/>')
						.attr('href',"#")
						.addClass('btn btn-link text-primary btn-control-delivery')
						.attr('data-orderid',item.node.id)
						.attr('title','Contrôler la commande')
						.append(
							$('<i/>')
							.addClass('fa fa-clipboard-list')
						);

						$list.append(
							$('<li/>')
							.addClass('list-inline-item')
							.append($btnShow)
							.append($btnControl)
						);

						//@todo rest of buttons

						return $list;
					},
				},

			]
		})
	}

	buildGraphQLParameters(){

		let startOfYearDay = moment().format('YYYY')+'-01-01';
		let filters = {
			"status" : 1,
			"verified" : false,
			"restaurantParticulier" : 0,
			"createdAt": ">= "+startOfYearDay
		};

		if(this.$filterByRestaurant && this.$filterByRestaurant.val()){
			filters.restaurant = parseInt(this.$filterByRestaurant.val());
		}

		if(this.$filterBySuppliers && this.$filterBySuppliers.val()){
			var selected = [];
			for (var option of this.$filterBySuppliers.val()) {
				selected.push(parseInt(option));
			}
			if(selected.length > 0)
				filters.suppliers = selected;
		}

		let parameters = {
			'orderBy' : "createdAt",
			'filter' : filters
		};

		return parameters;
	}

}

module.exports = ListView;